import { Wizard } from "@/components/instance/LaunchInstanceWizard";
import { useLocation } from "react-router-dom";

export const LaunchPool = () => {
  const location = useLocation();
  const { key, resource } = location.state || {};
  const title =
    key === "hadoop" ? "actions.launchHadoop" : "actions.launchMySQL";
  const description =
    key === "hadoop" ? "actionsDesc.launchHadoop" : "actionsDesc.launchMySQL";

  return (
    <Wizard
      instanceType={key}
      resource={resource}
      title={title}
      description={description}
    />
  );
};
